export const GET_ALL_SUBSCRIPTION = "GET_ALL_SUBSCRIPTION";
export const GET_ALL_SUBSCRIPTION_SUCCESS = "GET_ALL_SUBSCRIPTION_SUCCESS";
export const GET_ALL_SUBSCRIPTION_FAILED = "GET_ALL_SUBSCRIPTION_FAILED";